import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/floatingContactButtonStyle.css";
import { PHARMACY_NUMBER } from "../constants/constant";

const FloatingContactButtons = () => {
  const phoneNumber = "15877091323";
  const message = "Hello! I would like to know more about your pharmacy services.";

  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message
  )}`;

  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleCloseAndNavigate = (path) => {
    setOpen(false);
    navigate(path);
  };


  return (
    <div className="floating-contact">

      {/* Expandable menu */}
      <div className="fab-container">
        {open && (
          <>
            <button
              className="fab-item"
              onClick={() => handleCloseAndNavigate("/book-appointment")}
            >
              <i class="fa-solid fa-calendar"></i> <span>Appointment</span>
            </button>

            <button
              className="fab-item"
              onClick={() => handleCloseAndNavigate("/prescription-transfer")}
            >
              <i class="fa-solid fa-prescription"></i> <span>Transfer Rx</span>
            </button>

            <a
              href="https://www.google.com/maps?q=Mirror+Lake+Pharmacy+Care+Clinic+Camrose"
              target="_blank"
              rel="noreferrer"
              className="fab-item"
              onClick={() => setOpen(false)}
            >
              <i class="fa-solid fa-location-dot"></i> <span>Directions</span>
            </a>
          </>
        )}

        {/* Main FAB */}
        <button
          className={`fab-main ${open ? "active" : ""}`}
          onClick={() => setOpen(!open)}
        >
          {open ? "✕" : "➕"}
        </button>
      </div>

      {/* Call */}
      <a href={`tel:${PHARMACY_NUMBER}`} className="call-btn" title="Call Us">
        <i className="fa-solid fa-phone"></i>
      </a>

      {/* WhatsApp */}
      <a
        href={whatsappLink}
        target="_blank"
        rel="noreferrer"
        className="whatsapp-btn"
        title="Chat on WhatsApp"
      >
        <i className="fa-brands fa-whatsapp"></i>
      </a>
    </div>
  );
};

export default FloatingContactButtons;
